module.exports = __webpack_public_path__ + "static/img/success_header.0c42d51e.png";